<form
  [formGroup]="form"
  class="pb-xl">
  @let imageDataUrl = imageControl()?.value;
  @let showBackground = showBackgroundControl()?.value;

  <ng-container formGroupName="imageCardSettings">
    @if (!!imageDataUrl) {
      <div class="mb-lg">
        <div class="editor-preview-component mb-sm">
          @let styles = cardStyles()?.value;

          <img
            [src]="imageDataUrl"
            class="image-card"
            [style]="styles"
            [style.backgroundColor]="showBackground ? styles.backgroundColor : 'transparent'" />
        </div>
        <div class="image-actions">
          <button
            type="button"
            class="button is-secondary"
            topoFileUpload
            acceptedFileTypes=".png,.svg"
            readFileFormat="2"
            (fileUploaded)="handleImageUpload($event)">
            <i class="icon icon-cloud_upload"></i>
          </button>
          <button
            type="button"
            class="button is-danger"
            (click)="imageControl()?.setValue(null)">
            <i class="icon icon-delete_trash"></i>
          </button>
        </div>
      </div>

      <div class="mb-lg">
        <label>{{ 'MAP-DISPLAY.IMAGE-WIDGET.CARD-STYLES.SHOW-BACKGROUND' | translate }}</label>
        <topo-switch formControlName="showBackground" />
      </div>

      <ng-container formGroupName="cardStyles">
        @if (showBackground) {
          <div class="mb-lg">
            <label>{{ 'MAP-DISPLAY.IMAGE-WIDGET.CARD-STYLES.BACKGROUND-COLOR' | translate }}</label>
            <topo-color-picker
              formControlName="backgroundColor"
              displayAs="inline-narrow" />
          </div>
        }

        <div class="mb-lg">
          <topo-slider
            [label]="'MAP-DISPLAY.IMAGE-WIDGET.CARD-STYLES.OPACITY' | translate"
            [valueDisplayFormatter]="formatOpacityValueForDisplay"
            default="1"
            step="0.01"
            min="0.01"
            max="1"
            formControlName="opacity" />
        </div>
      </ng-container>
    } @else {
      <div
        class="image-dropzone"
        [class.has-error]="hasError"
        topoFileUpload
        acceptedFileTypes=".png,.svg"
        readFileFormat="2"
        (fileUploaded)="handleImageUpload($event)"
        (fileUploadError)="handleError($event)">
        <i class="icon icon-cloud_upload"></i>
        <span>{{ 'MAP-DISPLAY.IMAGE-WIDGET.UPLOAD-IMAGE' | translate }}</span>
        <span class="accepted-files-text">{{ 'MAP-DISPLAY.IMAGE-WIDGET.ACCEPTED-FILES-TEXT' | translate }}</span>
      </div>
    }
  </ng-container>
</form>
